import React from "react";

const DashboardCard = ({ title, icon, children, className = "", action }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md p-4 ${className} `}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
          {icon && <span className="text-gray-600">{icon}</span>}
        </div>
        {action && <div>{action}</div>}
      </div>
      <div className="space-y-2 max-h-[500px] overflow-y-auto">{children}</div>
    </div>
  );
};

export default DashboardCard;
